import { Injectable } from '@angular/core';
import { PromotionsV2Service } from 'app/promotionsv2/promotionsv2.service';
import { GenericEntity } from 'core/models/generic-entity.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export enum PromotionActionTypeV2 {
  Discount = 'Discount',
  BuyAPayB = 'BuyAPayB',
  BuyAGetDiscountInXUnit = 'BuyAGetDiscountInXUnit',
  Surcharge = 'Surcharge',
  FixPrice = 'FixPrice',
  Gift = 'Gift',
  Wholesaler = 'Wholesaler',
  ImageCommunication = 'ImageCommunication',
}

export const _aux_getEnumStringByIdPromotionTypes = (id, upcase = true) => {
  const _enum = dummyGenericPromotionTypesDataTypeOptions?.find(x => x?.id === id);
  const trad = _enum?.value?.toString();
  return upcase ? trad?.toUpperCase() : trad;
};

export const _aux_getIdByEnumStringPromotionTypes = value => {
  const _enum = dummyGenericPromotionTypesDataTypeOptions.find(x => x.value === value);
  return _enum.id;
};

export const dummyGenericPromotionTypesDataTypeOptions = [
  { id: 1, value: PromotionActionTypeV2.Discount },
  { id: 2, value: PromotionActionTypeV2.BuyAPayB },
  { id: 3, value: PromotionActionTypeV2.BuyAGetDiscountInXUnit },
  { id: 4, value: PromotionActionTypeV2.Surcharge },
  { id: 5, value: PromotionActionTypeV2.FixPrice },
  { id: 6, value: PromotionActionTypeV2.Gift },
  { id: 7, value: PromotionActionTypeV2.Wholesaler },
  { id: 8, value: PromotionActionTypeV2.ImageCommunication },
];

// PRM-786 / PRICING-020: filtra mecánicas del dropdown según dos flags unificados con el editor.
// - showFullActionForm=false → BÁSICO: solo Discount + FixPrice (+ ImageCommunication si showImageCommunicationMechanic=true).
// - showFullActionForm=true  → FULL: Discount, FixPrice, Gift, BuyAPayB, Surcharge (+ ImageCommunication si showImageCommunicationMechanic=true).
// Wholesaler nunca se incluye (no MVP).
// BuyAGetDiscountInXUnit (PRICING-020 Fase 1): NUNCA se ofrece en el dropdown — su caso de uso
// ("compra N, descuento en M unidades") se cubre desde Discount con `payUnits` opcional (Fase 2).
// Acciones EXISTENTES con este type siguen editándose; solo se retira del alta.
// PRICING-020: se unificó con `showFullActionForm` (antes existía `filterPromotionTypes` inverso; deprecado).
export function filterEnabledPromotionTypes(
  data: GenericEntity[],
  showFullActionForm: boolean,
  showImageCommunicationMechanic: boolean = false
): GenericEntity[] {
  const allowed: string[] = showFullActionForm
    ? [
        PromotionActionTypeV2.Discount,
        PromotionActionTypeV2.FixPrice,
        PromotionActionTypeV2.Gift,
        PromotionActionTypeV2.BuyAPayB,
        PromotionActionTypeV2.Surcharge,
      ]
    : [PromotionActionTypeV2.Discount, PromotionActionTypeV2.FixPrice];
  if (showImageCommunicationMechanic) allowed.push(PromotionActionTypeV2.ImageCommunication);
  return data.filter(p => allowed.includes(p.value as string));
}

@Injectable({
  providedIn: 'root',
})
export class GenericPromotionMasterTypeService {
  constructor(private promotionsV2Service: PromotionsV2Service) {}

  getGenericTypesOptions(): Observable<Array<GenericEntity>> {
    return of(dummyGenericPromotionTypesDataTypeOptions);
  }

  getPromotionProcessTypes(): Observable<any> {
    return this.promotionsV2Service.getPromotionProcessList();
  }

  // Backward compatibility while legacy callers are migrated.
  getItemsTypesOxxo(): Observable<any> {
    return this.getPromotionProcessTypes();
  }

  getItemspromotionTypeIdByCodeOrId(code): Observable<any> {
    return this.getPromotionProcessTypes().pipe(
      map(data => {
        return data.find(item => {
          const sameId = item?.id != null && String(item.id) === String(code);
          const sameCode = item?.code != null && String(item.code) === String(code);
          return sameId || sameCode;
        });
      })
    );
  }
}

const itemsTypesOxxoDummy = [
  {
    id: 110,
    value: 'Nacionales',
    name: 'Nacionales',
    code: 'NACIONALES',
    minimumCoverage: null,
    customFields: null,
  },
];
